import { useQueryClient } from '@tanstack/react-query'
import { apiPost } from '../axios.config'
import { API_ROUTES } from '../routes'
import { useMutationHook } from './mutationHook'

interface IDeleteAuthorParams {
  id: string
}

async function fetchDeleteAuthor(path: string, body: IDeleteAuthorParams) {
  const { data } = await apiPost<IDeleteAuthorParams, void>({ path, body })

  return data
}

export const useDeleteAuthor = (options?: { onSuccess?: () => void; onError?: (error: Error) => void }) => {
  const queryClient = useQueryClient()
  const path = API_ROUTES.AUTHOR_DELETE
  const mutationFn = (url: string, body: IDeleteAuthorParams) => fetchDeleteAuthor(url, body)
  const mutationFunc = useMutationHook({
    path,
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_ROUTES.AUTHORS],
      })
      options?.onSuccess?.()
    },
    onError: options?.onError,
  })

  return mutationFunc
}
